import React, {Component} from 'react';
import {observer} from 'mobx-react';
import styles from './styles.css';
import KasumikalkStore from './KasumikalkStore';

import Slider from 'react-toolbox/lib/slider';

@observer
export default class Kasumikalk extends Component {
  store = null;

  constructor() {
    super();
    this.store = new KasumikalkStore();
  }

  handleUpdateRent = value => this.store.updateRent(value);
  handleUpdateWage = value => this.store.updateWages(value);
  handleUpdateKBA = value => this.store.updateKBA(value);
  handleUpdateVersant = value => this.store.updateVersant(value);
  handleUpdateHalm = value => this.store.updateHalm(value);

  render() {
    const {store, handleUpdateHalm, handleUpdateKBA, handleUpdateRent, handleUpdateVersant, handleUpdateWage} = this;
    return (
      <form className={styles.form}>
        <legend>Kasumikalkulaator</legend>
        <div>
          <fieldset>
            <legend>Kulud</legend>
            <div className={styles.sliderWrapper}>
              <span>Rent</span>
              <Slider
                theme={styles}
                value={store.rent}
                onChange={handleUpdateRent}
                min={0}
                max={10000}
                step={1}
                editable
                pinned
              />
            </div>
            <span>Palk</span>
            <Slider theme={styles} value={store.wages} onChange={handleUpdateWage} min={0} max={50000} step={1} editable
                    pinned/>
            <span>Kulud kokku: {store.totalExpenses}</span>
          </fieldset>
          <fieldset>
            <legend>Tulud</legend>
            <span>KBA</span>
            <Slider theme={styles} value={store.kba} onChange={handleUpdateKBA} min={0} max={100000} step={1} editable
                    pinned/>
            <span>Versant</span>
            <Slider theme={styles} value={store.versant} onChange={handleUpdateVersant} min={0} max={100000} step={1}
                    editable pinned/>
            <span>Ümbrik</span>
            <Slider theme={styles} value={store.halm} onChange={handleUpdateHalm} min={0} max={100000} step={1} editable
                    pinned/>
            <span>Tulud kokku: {store.totalIncome}</span>
          </fieldset>
        </div>
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Kasumikalk/Kasumikalk.js